<template>
    <div class="">
        <div class="box box--spaces">
            <ul class="list list--primary list--bordered-clickable">
                <li v-for="link in links"
                    :key="link.id"
                    class="list__item"
                    :class="{
                        'list__item--selected': activeLink === link.id
                    }">
                    <a  href="#" @click.prevent.stop="() => onClick(link)"
                        class="item__content item__content--m item__content--bold-text">
                        {{link.title}}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "SidebarLinks",
    props: {
        links: {
            type: Array
        },
        activeLink: {
            type: String
        },
        onClick: {
            type: Function
        }
    }
}
</script>

